import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
const readToggle = (storageKey: string, defaultValue: boolean) => {
  if (typeof window === 'undefined') return defaultValue;
  try {
    const stored = window.localStorage.getItem(storageKey);
    return stored === null ? defaultValue : stored === 'true';
  } catch {
    return defaultValue;
  }
};
export const usePersistedToggle = (storageKey, defaultValue) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== defaultValue || $[1] !== storageKey) {
    t0 = () => readToggle(storageKey, defaultValue);
    $[0] = defaultValue;
    $[1] = storageKey;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [enabled, _setEnabled] = useState(t0);
  let t1;
  if ($[3] !== storageKey) {
    t1 = value => {
      _setEnabled(value);
      try {
        window.localStorage.setItem(storageKey, String(value));
      } catch {}
    };
    $[3] = storageKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const setEnabled = t1;
  let t2;
  if ($[5] !== enabled || $[6] !== setEnabled) {
    t2 = [enabled, setEnabled];
    $[5] = enabled;
    $[6] = setEnabled;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2 as const;
};